import { ShiftDirectionEnum } from '../../../../common/enum/shift-direction.enum';
import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { shiftDateToNearestGranularity } from '../../../../common/utils/datetime.util';
import { MetricValueType } from '../../../../interface/dtos';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../../../interface/dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';
import { ChallengeInsightProgressDigitalIntensitySummaryAggregateRoot } from '../../../domain/aggregates/challenge-insights/challenge-insight-progress-digital-intensity.aggregate-root';
import { GetChallengeInsightProgressDigitalIntensitySummaryDomainService } from '../../../domain/services/challenge-insights/get-challenge-insight-progress-digital-intensity-summary.domain-service';
import { OrganizationWorkingSessionsPort } from '../../ports/working-sessions/organization-working-sessions.port';

export class GetChallengeInsightProgressDigitalIntensitySummaryApplicationService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly port: OrganizationWorkingSessionsPort,
    protected readonly domainService: GetChallengeInsightProgressDigitalIntensitySummaryDomainService
  ) {}

  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressDigitalIntensitySummaryAggregateRoot> {
    try {
      this.logManager.debug(
        'Called GetChallengeInsightProgressDigitalIntensitySummaryApplicationService'
      );

      const shiftedEndDate = shiftDateToNearestGranularity({
        date: new Date(props.params.endDate),
        granularity: props.params.granularity,
        direction: ShiftDirectionEnum.Left,
      });
      const [entities, todayEntities] = await Promise.all([
        this.port.queryDigitalIntensityByDateRange({
          startDate: props.params.startDate,
          endDate: props.params.endDate,
          userIds: props.params.userIds,
          token: props.config.token,
          granularity: props.params.granularity,
          segments: props.params.segments ?? undefined,
          departmentId: props.params.departmentId ?? undefined,
        }),
        this.port.queryDigitalIntensityByDateRange({
          startDate: shiftedEndDate.toISOString().split('T')[0],
          endDate: props.params.endDate,
          userIds: props.params.userIds,
          token: props.config.token,
          granularity: props.params.granularity,
          departmentId: props.params.departmentId ?? undefined,
        }),
      ]);

      return await this.domainService.execute({
        entities,
        systemDayEntities: todayEntities,
        type: MetricValueType.Score,
        targetValue: props.params.challengeTargetValue,
      });
    } catch (error) {
      this.logManager.error(error);
      throw new InternalServerErrorException(error);
    }
  }
}
